import React, {useState} from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import {SmallGreyButton} from "../../../../misc/SmallGreyButton";
import {GlazingSubmittal} from "../glazingSubmittal/GlazingSubmittal";

// Opens the glazing submittal for the openings the workspace's rows cover. The openings grid is
// not mounted here, so the list is passed explicitly rather than read off that table.
export function GlazingSubmittalButton(props: {
    openings: number[];
}) {
    const [show, setShow] = useState(false);

    return (
        <>
            <SmallGreyButton startIcon={<AddCircleIcon />} onClick={() => setShow(true)}>
                Glazing Submittal
            </SmallGreyButton>
            {show && <GlazingSubmittal openings={props.openings} onDone={() => setShow(false)} />}
        </>
    )
}
